import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import { Grid, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'

import userActions from 'pages/User/actions'
import InviteEmailLinkForm from './InviteEmailLinkForm'
import { InviteType } from '../constants'
import { DialogContent, DialogTitle, DialogActions } from '@mui/material'

const useStyles = makeStyles((theme) => ({}))

const InviteUserDialog = () => {
    const classes = useStyles()
    const { isCreateDialogOpen, inviteType } = useSelector(
        (state) => state.user,
    )
    const { closeCreateDialog, setInviteType } = userActions()

    return (
        <Dialog
            fullWidth
            open={isCreateDialogOpen}
            onClose={closeCreateDialog}
        >
            <DialogTitle onClose={closeCreateDialog} id="form-dialog-title">
                Invite Users to Helios Workforce
            </DialogTitle>
            <DialogContent dividers>
                <Grid container direction="row" justify="space-around" mb={4}>
                    <Button
                        variant={
                            inviteType === InviteType.EMAIL
                                ? 'contained'
                                : 'outlined'
                        }
                        color={
                            inviteType === InviteType.EMAIL
                                ? 'primary'
                                : 'secondary'
                        }
                        onClick={() => {
                            setInviteType(InviteType.EMAIL)
                        }}
                    >
                        Invite with email
                    </Button>
                    {/* <Button
                        variant={
                            inviteType === InviteType.LINK
                                ? 'contained'
                                : 'outlined'
                        }
                        color={
                            inviteType === InviteType.LINK
                                ? 'primary'
                                : 'secondary'
                        }
                        onClick={() => {
                            setInviteType(InviteType.LINK)
                        }}
                        style={{ marginLeft: '10px' }}
                    >
                        Invite with link
                    </Button> */}
                </Grid>
                {(inviteType === InviteType.EMAIL ||
                    inviteType === InviteType.LINK) && <InviteEmailLinkForm handleClose={closeCreateDialog} />}
            </DialogContent>
        </Dialog>
    )
}

export default InviteUserDialog
